import { useQuery } from '@tanstack/react-query';
import { Megaphone } from 'lucide-react';
import { api } from '../../lib/api';

/**
 * Banner promocional inline no topo do dashboard (controlado pelo admin via
 * banner.promo). Mesma identidade azul do banner de restart; convive com ele.
 */
export function PromoBanner() {
  const meQuery = useQuery({ queryKey: ['trader-me'], queryFn: () => api.getTraderMe() });
  const banner = meQuery.data?.banners?.promo;
  if (!banner?.enabled || !banner.text) return null;

  return (
    <div className="rounded-xl bg-gradient-to-br from-[#0D1580] to-[#1E6FFF] p-5">
      <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <div className="grid h-10 w-10 shrink-0 place-items-center rounded-lg bg-white/15 text-white">
            <Megaphone size={18} />
          </div>
          <p className="text-sm leading-relaxed text-white/90 sm:text-base">{banner.text}</p>
        </div>
        {banner.buttonUrl && (
          <a
            href={banner.buttonUrl}
            target="_blank"
            rel="noreferrer"
            className="inline-flex shrink-0 items-center justify-center gap-2 rounded-md bg-white px-4 py-2.5 text-sm font-semibold text-[#0D1580] transition-colors hover:bg-white/90"
          >
            {banner.buttonText || 'Pegar o Desconto'}
          </a>
        )}
      </div>
    </div>
  );
}
